__turbopack_context__.v({
  "spinner": "spinner-module__z8pT-a__spinner",
  "wg-spin": "spinner-module__z8pT-a__wg-spin",
});
